<template>
    <nav
        class="app-nav-bar bg-gray-tier-3 border-b border-keyline-primary flex items-center h-12 px-4 z-20"
    >
        <button
            v-if="!hideBackButton"
            class="shrink-0 btn-app-icon-black-on-gray mr-2"
        >
            <span>
                <BaseSvg name="icon-chevron-left" />
                <span class="sr-only">{{ $t("Back") }}</span>
            </span>
        </button>
        <ul class="app-nav-bar__list flex font-medium h-full">
            <li
                v-if="links"
                v-for="(link, i) in links"
                :key="i"
                class="flex items-center relative"
            >
                <Link
                    :href="route(link?.route)"
                    class="app-nav-bar__trigger py-2 rounded hover:bg-gray-130 dark:hover:bg-gray-700 hover:type-primary"
                    :aria-current="route().current(link?.route) ? 'page' : null"
                    :class="{
                        'type-primary': route().current(
                            link?.route
                        ),
                        'type-tertiary': !route().current(
                            link?.route
                        ),
                    }"
                >
                    {{ $t(link?.text) }}
                </Link>
                <span
                    v-if="route().current(link?.route)"
                    aria-hidden="true"
                    class="absolute bg-blue block bottom-0 h-[2px] left-3 right-3"
                ></span>
            </li>
            <li
                v-else
                v-for="(section, i) in sections"
                class="flex items-center relative"
            >
                <a
                    :href="'#' + section.name"
                    v-if="!section.isHidden"
                    :key="i"
                    @click.prevent="sectionSelected(section)"
                    class="app-nav-bar__trigger py-2 rounded hover:bg-gray-130 dark:hover:bg-gray-700 hover:type-primary flex items-center gap-1"
                    :class="{
                        'type-primary':
                            section.name === modelValue,
                        'type-tertiary':
                            section.name !== modelValue,
                    }"
                >
                    {{ $t(section.name) }}
                    <BaseSvg v-if="section.isEmployeeOnly" name="icon-lock-shield" class="w-5 h-5 opacity-70" />
                </a>
                <span
                    v-if="section.name === modelValue"
                    aria-hidden="true"
                    class="absolute bg-blue block bottom-0 h-[2px] left-3 right-3"
                ></span>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { BaseSvg } from "@/Components";

const props = defineProps([
    "links",
    "sections",
    "modelValue",
    "hideBackButton",
]);
const emits = defineEmits(["scrollTo", "update:modelValue"]);

const sectionSelected = (section) => {
    emits("scrollTo", section.name);
    emits("update:modelValue", section.name);
};
</script>

<style>
.app-nav-bar {
    container-name: appNavBar;
    container-type: inline-size;
}

.app-nav-bar__trigger {
    @apply px-2;
}

@container appNavBar (min-width: 700px) {
    .app-nav-bar__list {
        @apply space-x-1;
    }

    .app-nav-bar__trigger {
        @apply px-3;
    }
}
</style>